import { useState, useEffect } from "react";

import "./stylesEditAdminPopup.css";

import { CloseOutlined } from "@ant-design/icons";

import { Select, message } from "antd";
import createPrivateAdminPanelInstance from "../../../api/PrivateAdminPanelInstance";
import { API_ROUTES } from "../../../api/ApiRoutes";

function EditAdminPopup({
  handleCancel,
  selectedAdmin,
  setData,
  data,
  isEditAdminModalOpen,
}) {
  console.log("selectedAdmin", selectedAdmin?.admin_name);
  const token = JSON.parse(localStorage.getItem("token"));
  const PrivateAdminPanelInstance = createPrivateAdminPanelInstance(
    token?.IdToken
  );

  const [messageApi, contextHolder] = message.useMessage();

  const [formData, setFormData] = useState({});

  const handleFieldChange = (field, value) => {
    setFormData({ ...formData, [field]: value });
  };

  const onCancel = () => {
    setFormData({});
    handleCancel();
  };

  useEffect(() => {
    if (selectedAdmin && isEditAdminModalOpen) {
      setFormData({
        group_name: selectedAdmin?.group_name,
        admin_id: selectedAdmin?.admin_id,
      });
    }
  }, [selectedAdmin, isEditAdminModalOpen]);

  const handleSave = async () => {
    const params = {
      group_name: formData.group_name,
      admin_id: selectedAdmin.admin_id,
    };

    try {
      await PrivateAdminPanelInstance?.post(API_ROUTES?.EDIT_ADMIN, params);

      message.success("Agent updated successfully!");
      setData(
        data.map((item) =>
          item.admin_id === selectedAdmin.admin_id
            ? { ...item, group_name: formData.group_name }
            : item
        )
      );
    } catch (error) {
      message.error("Error updating agent. Please try again.");
    } finally {
      onCancel();
    }
  };

  return (
    <div className="edit-admin-modal-container">
      {contextHolder}
      <div className="modal-header">
        <div className="modal-header-title">
          <h2 className="modal-title">Edit Agent</h2>
        </div>
        <CloseOutlined onClick={onCancel} className="close-icon" />
      </div>

      <div className="modal-content">
        <>
          <div className="divider" />

          <div className="transaction-info-item">
            <span>Role:</span>
            <Select
              value={formData.group_name}
              onChange={(value) => handleFieldChange("group_name", value)}
              options={[
                { value: "super-admin-v2", label: "Super Admin V2" },
                { value: "customer-support", label: "Customer Support" },
                { value: "customer-service", label: "Customer Service" },
              ]}
            />
          </div>
        </>
      </div>

      <div className="divider" />
      <div className="modal-footer">
        <div className="buttons">
          <button className="cancel-button" onClick={onCancel}>
            Close
          </button>
          <button className="save-button" onClick={handleSave}>
            Save
          </button>
        </div>
      </div>
    </div>
  );
}

export default EditAdminPopup;
